import Backbone from "backbone";

let warnGlobalBackboneUsage = true;
// tmp fix for scripts that should import Backbone instead of use global property
Object.defineProperty(window, "Backbone", {
  get: () => {
    if(warnGlobalBackboneUsage){
      console.warn("Use global Backbone is depreciated, use 'import Backbone from \"backbone\";' instead.");
    }
    warnGlobalBackboneUsage = false;
    return Backbone;
  }
});
